var React = require('react');

function Loupe (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8.14175 15.2835C12.086 15.2835 15.2835 12.086 15.2835 8.14175C15.2835 4.19747 12.086 1 8.14175 1C4.19747 1 1 4.19747 1 8.14175C1 12.086 4.19747 15.2835 8.14175 15.2835Z","stroke":"#318EFF","strokeWidth":"2","strokeMiterlimit":"10","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M18.4147 18.06L13.3398 12.9697","stroke":"#318EFF","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Loupe.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Loupe;

Loupe.default = Loupe;
